<!--详情背景组件 -->
<!--订单状态 status -->
<template>
  <div class="by">
    <div class="div-wp-bag">
      <van-row>
        <van-col span="10" class="wp-up-left">
          <van-icon v-if="status == 'COMPLETED'" name="passed" class="ic" />
          <van-icon v-if="status && status!= 'COMPLETED'" name="clock-o" class="ic" />
          <van-icon v-if="!status" name="close" class="ic" />
        </van-col>
        <van-col span="14" class="wp-up-rig">{{label || formatType[status]}}</van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
export default {
  props: {
    status: {
      type: String,
      default: "",
      required: false
    },
    label: {
      type: String,
      default: "",
      required: false
    },
    role: { 
      required: false
    }
  },
  data() {
    return {
      formatType: {
        WAIT_SEND: "待发货",
        IN_STOCK: "备货中",
        WAIT_RECEIVING: "待收货",
        WAIT_PAY: "待付款",
        CANCEL_ADMIN: "已取消",
        CANCEL_TIMEOUT: "超时关闭",
        COMPLETED: "已完成",
        CANCEL_USER: "已取消",
        AFTER_ING: "售后处理中"
      }
    };
  },
  methods: {},
  created() {},
  components: {}
};
</script>
<style lang="less" scoped rel="stylesheet/less">
.by {
  font-size: 0.4rem;
}
.div-wp-bag {
  background: -webkit-linear-gradient(#f8d541, #f28a1f); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(#f8d541, #f28a1f); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(#f8d541, #f28a1f); /* Firefox 3.6 - 15 */
  background: linear-gradient(#f8d541, #f28a1f); /* 标准的语法,必须放最后 */
  height: 1rem;
  line-height: 1rem;
  background-color: #f8d541;
  color: #fff;
  text-align: center;
  padding: 0.29rem 0.4rem;
  .wp-up-left {
    line-height: 1rem;
    text-align: right;
    .ic {
      padding-top: 0.3rem;
      padding-right: 0.1rem;
    }
  }
  .wp-up-rig {
    text-align: left;
  }
}
</style>